<ng-container *ngFor="let link of urlConfigData">
  <a
    class="btn btn-link"
    [href]="link.url"
    target="_blank"
  >
    {{ link.name }}
  </a>
</ng-container>
